import React,{useState} from 'react';
import {useAuth} from '../context/AuthContext';
import {useLang,LANGUAGES} from '../i18n';
import {useNavigate} from 'react-router-dom';
import {FormInput} from '../components/common';
import toast from 'react-hot-toast';

export default function LoginPage(){
  const[email,setEmail]=useState('');
  const[pw,setPw]=useState('');
  const[ld,setLd]=useState(false);
  const{login}=useAuth();
  const{t,lang,setLang}=useLang();
  const nav=useNavigate();

  const go=async e=>{
    e?.preventDefault?.();
    if(!email||!pw)return;
    setLd(true);
    try{
      await login(email,pw);
      toast.success(t('auth.welcomeBack'));
      nav('/');
    }catch(err){
      toast.error(err.response?.data?.error||t('auth.loginFailed'));
    }finally{setLd(false)}
  };

  return(
    <div className="login-page">
      <div className="login-card">
        {/* Language switcher at top */}
        <div style={{display:'flex',justifyContent:'flex-end',marginBottom:16,gap:6}}>
          {LANGUAGES.map(l=>(
            <button key={l.code} onClick={()=>setLang(l.code)}
              style={{
                display:'flex',alignItems:'center',gap:5,
                padding:'5px 10px',borderRadius:8,fontSize:12,fontWeight:600,
                cursor:'pointer',border:'1px solid',transition:'all .15s',
                borderColor:lang===l.code?'var(--primary)':'var(--border)',
                background:lang===l.code?'var(--pm)':'transparent',
                color:lang===l.code?'var(--primary)':'var(--td)',
              }}>
              <span style={{fontSize:14}}>{l.flag}</span>
              <span>{l.nativeLabel}</span>
            </button>
          ))}
        </div>

        <h1>ERP<span>hub</span></h1>
        <p className="text-muted" style={{marginBottom:24,fontSize:13}}>{t('common.appTagline')}</p>

        <form onSubmit={go}>
          <FormInput label={t('auth.email')} value={email} onChange={setEmail}/>
          <FormInput label={t('auth.password')} value={pw} onChange={setPw} type="password"/>
          <button className="btn btn-primary" type="submit" disabled={ld}
            style={{width:'100%',justifyContent:'center',marginTop:6,padding:'11px 0'}}>
            {ld?t('auth.signingIn'):t('auth.signIn')}
          </button>
        </form>
      </div>
    </div>
  );
}
